import { store } from "../../store";
import { TempKeys, TemplateTEMPObject } from "@services/storage/storeTemplate";
import * as reducer from "./slice";

export const dispatchHydrateTemp = (state: TemplateTEMPObject) => {
  store.dispatch(
    reducer.hydrate({
      value: state,
    })
  );
};

export const dispatchSetTemp = (name: TempKeys, payload: any) => {
  store.dispatch(
    reducer.set({
      name,
      value: payload,
    })
  );
};

export const dispatchResetTemp = () => {
  store.dispatch(reducer.reset());
};

export const dispatchSaveTemp = () => {
  store.dispatch(reducer.save());
};

export default reducer;
